jQuery(function($) {
  /* ===SKIP LINKS=== */

  var skipContents = $(".skip-content");
  var skipLinks = $(".skip-link");

  skipLinks.on("click", function (e) {
    e.preventDefault();

    var self = $(this);
    // Use the data-target-element attribute, if it exists. Fall back to href.
    var target = self.attr("data-target-element")
      ? self.attr("data-target-element")
      : self.attr("href");

    // Get target element
    var elem = $(target);

    // Check if stub is open
    var isSkipContentOpen = elem.hasClass("skip-active") ? 1 : 0;

    // Hide all stubs
    skipLinks.removeClass("skip-active");
    skipContents.removeClass("skip-active");

    // Toggle stubs
    if (isSkipContentOpen) {
      self.removeClass("skip-active");
    } else {
      self.addClass("skip-active");
      elem.addClass("skip-active");
    }
  });

  $("#header-cart").on("click", ".skip-link-close", function (e) {
    var parent = $(this).parents(".skip-content");
    var link = parent.siblings(".skip-link");

    parent.removeClass("skip-active");
    link.removeClass("skip-active");

    e.preventDefault();
  });

  /* ===NAVBAR=== */

  $(".nav-submenu-link").on("click", function (e) {
    e.preventDefault();
    let navSubmenuTop = $(this).parent();
    let isActive = navSubmenuTop.hasClass("menu-active");
    isActive
      ? navSubmenuTop.removeClass("menu-active")
      : navSubmenuTop.addClass("menu-active");
  });

  $("#header-account-link").on("click", function (e) {
    e.preventDefault();
  });

  /* ===SIDEBAR=== */

  function toggleMenu(element) {
    if (element.hasClass("hidden")) {
      element.removeClass("hidden");
      element.attr("expanded", true);
    } else {
      element.addClass("hidden");
      element.attr("expanded", false);
    }
  }

  $(".sidebar-submenu-link").on("click", function (e) {
    e.preventDefault();
    toggleMenu($(e.currentTarget).siblings(".sidebar-submenu"));
  });

  const path = window.location.pathname.toLowerCase();

  // Need to match the path or path segments

  function matchPath(basePath) {
    let re = new RegExp(`[/]${basePath}([/][\S^/]+)?`);
    return path.match(re) || {};
  }

  switch (path) {
    case matchPath("pcb-drill-bits").input:
      toggleMenu($("#sidebar-submenu-pcb-drill-bits"));
      break;
    case matchPath("pcb-routers").input:
      toggleMenu($("#sidebar-submenu-pcb-routers"));
      break;
    case matchPath("diamond-files").input:
      toggleMenu($("#sidebar-submenu-diamond-files"));
      break;
    case matchPath("carbide-end-mills").input:
      toggleMenu($("#sidebar-submenu-carbide-end-mills"));
      break;
    case matchPath("pcb-end-mills").input:
      toggleMenu($("#sidebar-submenu-pcb-end-mills"));
      break;
    case matchPath("amb-spindle").input:
      toggleMenu($("#sidebar-submenu-amb-spindle"));
      break;
  }

  /* ===SEARCH AUTOCOMPLETE=== */

  $("#search").autocomplete({
    source: "/suggestions",
    select: function () {
      $("#search_mini_form").submit();
    }
  });

});

  /* ===PRODUCT TOOLBAR SORT/PAGER=== */
  function setParams(key, value) {
    if ('URLSearchParams' in window) {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set(key, value);
      if (key == "per_page") {
        searchParams.set("page", "1");
      }
      window.location.search = searchParams.toString();
    }
  }

  window.setParams = setParams